import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { ERROR, NEW, UNCHANGED, UPDATED } from 'modules/payroll_bundle/lib/constants'

import { isValid } from './RowValidations'

/**
 * We need to format the amount with two decimals to avoid unexpected errors comparing two of them with
 * different decimal digits
 */
const getAmountFormatted = (value: number | null): string | null => {
  const amount = Number(value)

  return isNaN(amount) ? null : amount.toFixed(2)
}

export const isResultItemEquals = (source: ImportData, other: ImportData): boolean => {
  const isEqualEmployeeId = source.employee_id === other.employee_id
  const isEqualNetSalary =
    getAmountFormatted(source.net_salary) === getAmountFormatted(other.net_salary)
  const isEqualGrossSalary =
    getAmountFormatted(source.gross_salary) === getAmountFormatted(other.gross_salary)
  const isEqualCompanyCost =
    getAmountFormatted(Number(source.company_costs)) ===
    getAmountFormatted(Number(other.company_costs))

  return isEqualEmployeeId && isEqualNetSalary && isEqualGrossSalary && isEqualCompanyCost
}

export const getResultFileStatus = (resultItem: ImportData, pastResultItem?: ImportData) => {
  // It is very important to validate if a result item contains an error before performing other checks. The main reason is
  // that a new item could contain an error. In that case, even if the item is new, we have to return "ERROR" status.
  if (!isValid(resultItem)) {
    return ERROR
  }

  if (!pastResultItem) return NEW

  return isResultItemEquals(resultItem, pastResultItem) ? UNCHANGED : UPDATED
}
